import { IState } from '../../../store';

export function selectUserEmail(state: IState) {
  return state.offerData.user?.email || '';
}
